import React from 'react'

/* package */
import { SectionWrappList } from '../../lib-atomic-section'
/* package */

/* container */
import CampaignContainer from '../../app-campaign-container/default'
/* container */

/* form */
import Content from '../layout/content'
/* form */

const index = (props) => {
  return (
    <CampaignContainer.CampaignList {...props}>
      <SectionWrappList {...props}>
        <Content {...props} />
      </SectionWrappList>
    </CampaignContainer.CampaignList>
  )
}

export default index
